/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RequestReason = {
    DEPOSIT: 'deposit',
    WITHDRAWAL: 'withdrawal',
    CLIENT_DIRECTED: 'client_directed',
    ONBOARDING: 'onboarding',
    STRATEGY_CHANGE: 'strategy_change',
    OTHER: 'other',
    CASHFLOW: 'cashflow'
} as const;
export type RequestReason = typeof RequestReason[keyof typeof RequestReason];


export function instanceOfRequestReason(value: any): boolean {
    for (const key in RequestReason) {
        if (Object.prototype.hasOwnProperty.call(RequestReason, key)) {
            if (RequestReason[key as keyof typeof RequestReason] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RequestReasonFromJSON(json: any): RequestReason {
    return RequestReasonFromJSONTyped(json, false);
}

export function RequestReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestReason {
    return json as RequestReason;
}

export function RequestReasonToJSON(value?: RequestReason | null): any {
    return value as any;
}

export function RequestReasonToJSONTyped(value: any, ignoreDiscriminator: boolean): RequestReason {
    return value as RequestReason;
}

